<template>
  <div>
    <body v-if="order !== null">
    <header>
            <!-- <img src="images/logo.png" alt="printshop logo" style="max-height:75px;margin: 5px;"> -->
			<h1>{{ isCreditDoc ? 'Credit Invoice' : 'Invoice' }}</h1>
			<span><img :src="logo" alt="logo" class="logo"></span>
			<address>
				<p><b>VestiGO Logistics Ltd, trading as VestiGO Brand Solutions. </b></p>
				<!-- <p v-if="order.deliveryAddress !== null">{{ order.deliveryAddress.addressOne }}<br> {{ order.deliveryAddress.addressTwo }} <br> 
                    {{ order.deliveryAddress.city }}, {{ order.deliveryAddress.county }}, {{ order.deliveryAddress.country }} {{ order.deliveryAddress.postCode ? order.deliveryAddress.postCode.toUpperCase() : '' }}</p> -->
				<p>21 Oak Avenue, Royal Oak, Santry, <br>Dublin 9 D09 EOY7</p>
				<p>info@vestigobrandsolutions.com</p>
				
			</address>
			
		</header>

    <article>
			<div class="invoice-address">
				<b>{{ isCreditDoc ? 'Credit Invoice Address' : 'Invoice Address' }}</b>
				<P>{{ displayUser.accountTitle }}</P>
				<p><p v-if="invoiceBilling">{{ invoiceBilling.addressOne }}<br> {{ invoiceBilling.addressTwo }} <br>
                    {{ invoiceBilling.city }}, {{ invoiceBilling.county }}, {{ invoiceBilling.country }} {{ invoiceBilling.postCode }}</p></p>
			</div>
			<div class="delivery-address">
				<!-- <b>Delivery Address</b>
				<p v-if="order.deliveryAddress !== null">{{ order.deliveryAddress.addressOne }}<br> {{ order.deliveryAddress.addressTwo }} <br> 
                    {{ order.deliveryAddress.city }}, {{ order.deliveryAddress.country }} {{ order.deliveryAddress.postCode }}</p> -->
			</div>
		</article>

    <article>
			<!-- <h1 style="text-align: center; margin: 5px;">Recipient</h1> -->
			<!-- <address>
				<p>Some Company<br>c/o >{{ order.user.name}} {{(order.user.lastName !== undefined) ? order.user.lastName : "" }}</p>
			</address> -->
			<table class="meta">
				<tr>
					<th><span>Invoice #</span></th>
					<td><span>{{ order.invoiceNumber }}</span></td>
				</tr>
				<tr>
					<th><span>Date</span></th>
					<td><span> 
							{{
								new Date(order.createdAt).getDate().toString().padStart(2, '0') + '-' +
								(new Date(order.createdAt).getMonth() + 1).toString().padStart(2, '0') + '-' +
								new Date(order.createdAt).getFullYear()
							}} 
						</span>
					</td>
				</tr>
				<tr>
					<th><span>Amount Due</span></th>
					<td ><span id="prefix"></span><span>&euro; {{ $calculateItemTotal(order.items[0].quantity.sellingProductPrice, [order.items[0].discountPromoCodeAm, order.items[0].discountPCPAm, order.items[0].spendDiscountAm], order.items[0].vat).toFixed(2) }}</span></td>
				</tr>
				<tr>
					<th><span>Order No</span></th>
					<td ><span id="prefix"></span><span> {{ order.orderNumber }}</span></td>
				</tr>
				<!-- <tr>
					<th><span>PO No</span></th>
					<td ><span id="prefix"></span><span> </span></td>
				</tr> -->
			</table>
			<table class="inventory">
				<thead>
					<tr>
						<th><span>Item</span></th>
						<th><span>Product Description</span></th>
						<th><span>Quantity</span></th>
						<th><span>Price</span></th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td style="vertical-align: top;"><a class="cut">-</a><span>{{ productName }}</span></td>
							
						<td v-if="itemProduct && itemProduct.nonPrint == 'Non Print'"><span>{{ productName }}</span></td>
						<td v-else-if="itemProduct && itemProduct.nonPrint == 'Print'">
							<template v-if="itemDetails && itemDetails.printed">
								<b>Printed : </b>{{ itemDetails.printed }}<br>
							</template>
							<template v-if="itemDetails && itemDetails.finishing">
								<b>Finishing : </b>{{ itemDetails.finishing }}<br>
							</template>
							<template v-if="itemDetails && itemDetails.productPaperSizeFormat">
								<b>Size : </b>{{ itemDetails.productPaperSizeFormat }}<br>
							</template>
							<template v-if="itemDetails && itemDetails.productPaperTypeWeight">
								<b>Weight : </b>{{ itemDetails.productPaperTypeWeight }}<br>
							</template>
							<template v-if="itemDetails && itemDetails.bookletType">
								<b>Booklet type : </b>{{ itemDetails.bookletType }}<br>
							</template>
							<template v-if="itemDetails && itemDetails.material">
								<b>Materials : </b>{{ itemDetails.material }}<br>
							</template>
							<template v-if="itemDetails && itemDetails.lamination">
								<b>Laminations : </b>{{ itemDetails.lamination }}<br>
							</template>
							<template v-if="itemDetails && itemDetails.foldingOption">
								<b>Folding Option : </b>{{ itemDetails.foldingOption }}<br>
							</template>
							<template v-if="itemDetails && itemDetails.orient">
								<b>Orient : </b>{{ itemDetails.orient }}<br>
							</template>
							<template v-if="itemDetails && itemDetails.bookletPagination">
								<b>Pagination : </b>{{ itemDetails.bookletPagination }}
							</template>
						</td>
						<td v-else>
							<span>{{ productName }}</span>
						</td>
						<td><span>{{ order.items[0].quantity.quantity }}</span></td>
						<td ><span data-prefix></span>
							<span>&euro; {{ $roundCurrency(order.items[0].quantity.sellingProductPrice).toFixed(2)}}</span>
							<br>
							<span v-if="(order.items[0].discountPromoCodeAm + order.items[0].discountPCPAm  + order.items[0].spendDiscountAm ) !== 0">
								Discounts applied : &euro; {{ $sumRoundedDiscounts([order.items[0].discountPromoCodeAm, order.items[0].discountPCPAm, order.items[0].spendDiscountAm]).toFixed(2) }}
							</span>
						</td>
					</tr>
				</tbody>
			</table>
			<article style="float: left;">
			<div class="invoice-address">
				<P><b>BANK DETAILS</b></P>
				<p><b>ACCOUNT NAME :</b> VESTIGO LOGISTICS LIMITED</p>
				<p><b>IBAN NO :</b> 1E81BOFI90047112662562</p>
				<p><b>BIC/SWIFT CODE :</b> BOFIIE2D</p>
			</div>
		</article>
			<table class="balance">
				<tr>
					<th><span>Sub Total</span></th>
					<td v-if="isCreditDoc"><span  class="color-red"> &euro; -{{ $calculateSubtotal(order.items[0].quantity.sellingProductPrice, [order.items[0].discountPromoCodeAm, order.items[0].discountPCPAm, order.items[0].spendDiscountAm]).toFixed(2) }}</span></td>
					<td v-else > &euro; <span> {{ $calculateSubtotal(order.items[0].quantity.sellingProductPrice, [order.items[0].discountPromoCodeAm, order.items[0].discountPCPAm, order.items[0].spendDiscountAm]).toFixed(2) }}</span></td>
					
				</tr>
				<tr>
					<th><span>VAT ({{ vatPersent }}%)</span></th>
					<td v-if="isCreditDoc"><span class="color-red">&euro; -{{ Number(order.items[0].vat).toFixed(2) }}</span></td>
					<td v-else ><span>&euro; {{ Number(order.items[0].vat).toFixed(2) }}</span></td>
				</tr>
				<tr>
					<th><span>Total</span></th>
					<td v-if="isCreditDoc" ><span class="color-red">&euro; -{{ $calculateItemTotal(order.items[0].quantity.sellingProductPrice, [order.items[0].discountPromoCodeAm, order.items[0].discountPCPAm, order.items[0].spendDiscountAm], order.items[0].vat).toFixed(2) }}</span></td>
					<td v-else ><span >&euro; {{ $calculateItemTotal(order.items[0].quantity.sellingProductPrice, [order.items[0].discountPromoCodeAm, order.items[0].discountPCPAm, order.items[0].spendDiscountAm], order.items[0].vat).toFixed(2) }}</span></td>
				</tr>
			</table>
		</article>

    <aside>
			<h1><span>Additional Notes</span></h1>
			<div>
				<P v-if="order.paymentStatus === 'Awaiting Payment'">{{ getPaymentMessage(order.createdAt, displayUser ? displayUser.accountTerms : '') }}</P>
              	<P v-else> {{ order.paymentStatusDes ? order.paymentStatusDes : '' }}</P>
				<p v-if="order.paymentMethod === 'Credit'" style="font-weight: bold;">
					Payment Terms {{ displayUser ? displayUser.accountTerms : '' }} Days from receipt of Invoice.
				</p>
			</div>
		</aside>
  </body>
  </div>
</template>

<script>
import logo from '@/assets/logo/logo.png';
import axios from 'axios';

export default {
  props: {
    order: {
      type: Object,
      default: null
    },
    docType: {
      type: String,
      default: 'invoice' // 'invoice' | 'credit'
    }
  },
  data() {
    return {
      logo,
      fetchedUser: null,
    //   URL: "http://localhost:3030",
      URL: "https://vestigobrandsolutions.com",
    };
  },
  computed: {
    isCreditDoc() {
      return this.docType ? this.docType === 'credit' : this.order.status === 'Order Cancelled';
    },
    itemProduct() {
      return this.order?.items?.[0]?.product?.product || null;
    },
    itemDetails() {
      return this.order?.items?.[0]?.product || null;
    },
    itemQuote() {
      return this.order?.items?.[0]?.quote_id || null;
    },
    productName() {
      if (this.itemProduct && this.itemProduct.productName) {
        return this.itemProduct.productName;
      }
      if (this.itemQuote) {
        return this.itemQuote.suppliersDesription || this.itemQuote.quotesProduct || 'Quote Item';
      }
      return 'Product';
    },
    vatPersent() {
      if (this.itemProduct && this.itemProduct.supplierVAT !== undefined) {
        return Number(this.itemProduct.supplierVAT).toFixed(2);
      }
      const item = this.order?.items?.[0];
      if (item && item.quantity && item.quantity.supplierVATNumber !== undefined) {
        return Number(item.quantity.supplierVATNumber).toFixed(2);
      }
      return '0.00';
    },
    invoiceBilling() {
      // Billing address captured when the order was placed; falls back to the
      // customer's current default billing for older orders.
      let bill = this.order ? this.order.billingAddress : null;
      if (!bill || !(bill.billAddressOne || bill.addressOne)) {
        bill = (this.order && this.order.user && typeof this.order.user === 'object') ? this.order.user.billing : null;
      }
      if (!bill) return null;
      return {
        addressOne: bill.billAddressOne ? bill.billAddressOne : bill.addressOne,
        addressTwo: bill.billAddressTwo ? bill.billAddressTwo : bill.addressTwo,
        city: bill.billCity ? bill.billCity : bill.city,
        county: bill.billCounty ? bill.billCounty : bill.county,
        country: bill.billCountry ? bill.billCountry : bill.country,
        postCode: bill.billPostCode ? bill.billPostCode : bill.postCode,
      };
    },
    displayUser() {
      if (this.fetchedUser) {
        return this.fetchedUser;
      }
      if (this.order && typeof this.order.user === 'object' && this.order.user !== null) {
        return this.order.user;
      }
      return {}; // Return an empty object to prevent template errors
    }
  },
  watch: {
    order: {
      handler(newOrder) {
        if (newOrder && typeof newOrder.user === 'string') {
          this.fetchUserData(newOrder.user);
        } else {
          // If user is already an object or null, no need to fetch.
          // Reset fetchedUser if order changes to one with a user object.
          this.fetchedUser = null;
        }
      },
      immediate: true, // Fire the handler immediately on component mount
      deep: true // Watch for nested changes in the order object
    }
  },
  methods: {
    getPaymentMessage(createdAt, totalDays) {
      if (!createdAt || !totalDays) return '';

      const created = new Date(createdAt);
      const endDate = new Date(created.getTime() + totalDays * 86400000);
      const today = new Date();
      const diffTime = endDate - today;
      const diffDays = Math.ceil(diffTime / 86400000);

      return diffDays <= 0
        ? 'Payment overdue'
		: 'Payment transfers can take 3-5 Working Days';
        // : `Payment can take ${diffDays} Working Day${diffDays > 1 ? 's' : ''}`;
    },
    async fetchUserData(userId) {
      // Check for this.$store availability for production robustness, but fallback to hardcoded URL
      const baseUrl = (this.$store && this.$store.state && this.$store.state.URL) ? this.$store.state.URL : this.URL;
      try {
        const res = await axios.get(`${baseUrl}/api/get/user/${userId}`);
        if (res.data.user) {
          this.fetchedUser = res.data.user;
        }
      } catch (error) {
        console.error('Failed to fetch user data:', error);
        this.fetchedUser = { name: 'Unable to fetch user', lastName: '' }; // Provide feedback on UI
      }
    }
  }
};
</script>


<style scoped>
/* *
{
border: 0;
box-sizing: content-box;
color: inherit;
~	font-family: inherit;
font-size: inherit;
font-style: inherit;
font-weight: inherit;
line-height: inherit;
list-style: none;
margin: 0;
padding: 0;
text-decoration: none;
vertical-align: top;
} */

/* content editable */

body.disable-style-main * {
    all: unset !important;
  }

.logo {
  max-width: 150px;
}

*[contenteditable] { border-radius: 0.25em; min-width: 1em; outline: 0; }

*[contenteditable] { cursor: pointer; }

*[contenteditable]:hover, *[contenteditable]:focus, td:hover *[contenteditable], td:focus *[contenteditable], img.hover { background: #DEF; box-shadow: 0 0 1em 0.5em #DEF; }

span[contenteditable] { display: inline-block; }

/* heading */

h1 { font: bold 100% sans-serif; letter-spacing: 0.5em; text-align: center; text-transform: uppercase; }

/* table */

table { font-size: 75%; table-layout: fixed; width: 100%; }
table { border-collapse: separate; border-spacing: 2px; }
th, td { border-width: 1px; padding: 0.5em; position: relative; text-align: left; }
th, td { border-radius: 0.25em; border-style: solid; }
th { background: #EEE; border-color: #BBB; }
td { border-color: #DDD; }

/* page */

html { font: 16px/1 'Open Sans', sans-serif; overflow: auto; padding: 0.5in; }
html { background: #999; cursor: default; }

body { box-sizing: border-box; height: 11in; margin: 0 auto; overflow: hidden; padding: 0.5in; width: 8.5in; }
body { background: #FFF; border-radius: 1px; box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5); }

/* header */

header { margin: 0 0 3em; }
header:after { clear: both; content: ""; display: table; }

header h1 { background: #000; border-radius: 0.25em; color: #FFF; margin: 0 0 1em; padding: 0.5em 0; }
header address { float: right; font-size: 75%; font-style: normal; line-height: 1.25; margin: 0 1em 1em 0; }
header address p { margin: 0 0 0.25em; }
header span, header img { display: block; float: left; }
header span { margin: 0 0 1em 1em; max-height: 25%; max-width: 60%; position: relative; }
header img { max-height: 100%; max-width: 100%; }
header input { cursor: pointer; -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; height: 100%; left: 0; opacity: 0; position: absolute; top: 0; width: 100%; }

/* article */

article .invoice-address { float: left;}
article .delivery-address { float: right;}

.color-red { color: red;}

article, article address, table.meta, table.inventory { margin: 0 0 3em; }
article:after { clear: both; content: ""; display: table; }
article h1 { clip: rect(0 0 0 0); position: absolute; }

article address { float: left; font-size: 125%; font-weight: bold; }

/* table meta & balance */

table.meta, table.balance { float: right; width: 36%; }
table.meta:after, table.balance:after { clear: both; content: ""; display: table; }

/* table meta */

table.meta th { width: 40%; }
table.meta td { width: 60%; }

/* table items */

table.inventory { clear: both; width: 100%; }
table.inventory th { font-weight: bold; text-align: center; }

table.inventory td:nth-child(1) { width: 26%; }
table.inventory td:nth-child(2) { width: 38%; }
table.inventory td:nth-child(3) { text-align: right; width: 12%; }
table.inventory td:nth-child(4) { text-align: right; width: 12%; }
table.inventory td:nth-child(5) { text-align: right; width: 12%; }

/* table balance */

table.balance th, table.balance td { width: 50%; }
table.balance td { text-align: right; }

/* aside */

aside h1 { border: none; border-width: 0 0 1px; margin: 0 0 1em; }
aside h1 { border-color: #999; border-bottom-style: solid; }

/* javascript */

.add, .cut
{
border-width: 1px;
display: block;
font-size: .8rem;
padding: 0.25em 0.5em;	
float: left;
text-align: center;
width: 0.6em;
}

.add, .cut
{
background: #9AF;
box-shadow: 0 1px 2px rgba(0,0,0,0.2);
background-image: -moz-linear-gradient(#00ADEE 5%, #0078A5 100%);
background-image: -webkit-linear-gradient(#00ADEE 5%, #0078A5 100%);
border-radius: 0.5em;
border-color: #0076A3;
color: #FFF;
cursor: pointer;
font-weight: bold;
text-shadow: 0 -1px 2px rgba(0,0,0,0.333);
}

.add { margin: -2.5em 0 0; }

.add:hover { background: #00ADEE; }

.cut { opacity: 0; position: absolute; top: 0; left: -1.5em; }
.cut { -webkit-transition: opacity 100ms ease-in; }

tr:hover .cut { opacity: 1; }

@media print {
* { -webkit-print-color-adjust: exact; }
html { background: none; padding: 0; }
body { box-shadow: none; margin: 0; }
span:empty { display: none; }
.add, .cut { display: none; }
}

@page { margin: 0; }

</style>
